import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { CcHpiConstants } from '../store/ccHpi.constants'
import { ICcHpiCardiacArrestState } from '../store/ccHpi.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getCardiacArrestSelector } from '../selectors/cardiacArrest.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveCardiacArrest() {
  const ccHpiCardiacArrest: ICcHpiCardiacArrestState = yield select(getCardiacArrestSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      ccHpiCardiacArrest,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveCardiacArrest() error: ${e}`))
    }
  } else {
    yield put(throwPcrException('pcrID not found'))
  }
}
export function* saveCardiacArrestSaga() {
  yield takeLatest(
    [
      CcHpiConstants.SAVE_CARDIAC_ARREST,
      CcHpiConstants.SET_ARREST_PRESENT,
      CcHpiConstants.SET_ARREST_PRESENT_PNNV,
      CcHpiConstants.SET_DTWITNESSED,
      CcHpiConstants.SET_DTWITNESSED_PNNV,
      CcHpiConstants.SET_ETIOLOGY,
      CcHpiConstants.SET_ETIOLOGY_PNNV,
      CcHpiConstants.SET_THERAPEUTIC_HYPOTHERMIA,
      CcHpiConstants.SET_INITIAL_RHYTHM,
      CcHpiConstants.SET_INITIAL_RHYTHM_PNNV,
      CcHpiConstants.SET_CPR_PRIOR_EMS_ARRIVAL,
      CcHpiConstants.SET_CPR_PRIOR_EMS_ARRIVAL_PNNV,
      CcHpiConstants.SET_DTCPR,
      CcHpiConstants.SET_FIRST_CPR,
      CcHpiConstants.SET_FIRST_CPR_PNNV,
      CcHpiConstants.SET_AED_USE,
      CcHpiConstants.SET_FIRST_AED_BY,
      CcHpiConstants.SET_FIRST_AED_BY_PNNV,
      CcHpiConstants.SET_DTDEFIB,
      CcHpiConstants.SET_DEFIB_TYPE,
      CcHpiConstants.SET_DEFIB_BY,
      CcHpiConstants.SET_DEFIB_BY_PNNV,
      CcHpiConstants.SET_DTALS,
      CcHpiConstants.SET_DTDISC,
      CcHpiConstants.SET_DISC_REASON,
      CcHpiConstants.SET_DISC_REASON_PNNV,
      CcHpiConstants.SET_DTCIRCULATION,
      CcHpiConstants.SET_DTVENT,
      CcHpiConstants.SET_ARREST_RESULT,
    ],
    performWithMutexHOG,
    saveCardiacArrest
  )
}
